/**
 * @author - steves165
 */

(function() {
    'use strict';

    angular.module('vhols')

        .directive('thumbnailImageCarousel', function() {
            return {
                scope: {
                    thumbImages : '='
                },
                link: function($scope, $element) {
                    setTimeout(function() {
                        var $indicatorsSection = angular.element($element[0].querySelectorAll('.carousel-indicators'));
                        var $indicators = $indicatorsSection.find('li');

                        if ($indicators.length && $scope.thumbImages && $scope.thumbImages.length) {
                            angular.forEach($indicators, function(indicator, index) {
                                indicator.setAttribute('style', 'background-image:url(' + $scope.thumbImages[index] + ');');
                            });
                        }
                        else {
                            $indicatorsSection.addClass('hide');
                        }
                    }, 500);
                }
            };
        })

        .directive('cabinCarousel', [function() {
            return {
                restrict: 'A',
                link: function($scope, $element, $attr) {
                    $scope.selectedCabin = $scope.cabins[0];

                    $scope.$on('destroy', $scope.$on('slideChange', function(e, index) {
                        if (index === 'next') {
                            nextSlide();
                        }
                        else if (index === 'prev') {
                            prevSlide();
                        }
                        else {
                            $scope.selectedCabin = $scope.cabins[index];
                        }
                    }));

                    setTimeout(function() {
                        var $indicatorsSection = angular.element($element[0].querySelectorAll('.carousel-indicators'));
                        var $indicators = $indicatorsSection.find('li');

                        if ($indicators.length && $scope.cabins.length) {
                            angular.forEach($indicators, function(indicator, index) {
                                var cabinTitleEl = document.createElement('span');
                                cabinTitleEl.innerHTML = $scope.cabins[index].cabinTitle;
                                indicator.appendChild(cabinTitleEl);
                                if (!!$scope.cabins[index].image && !!$scope.cabins[index].image.variants) {
                                    indicator.setAttribute('style', 'background-image:url(' + $scope.cabins[index].image.variants['16_9_MOBILE_MAIN'] + ');');
                                }
                            });
                        }
                        else {
                            $indicatorsSection.addClass('hidden');
                        }
                    }, 500);

                    function prevSlide() {
                        var currentIndex = $scope.cabins.indexOf($scope.selectedCabin),
                            index = currentIndex === 0 ? $scope.cabins.length - 1 : currentIndex - 1;
                        $scope.selectedCabin = $scope.cabins[index];
                    }

                    function nextSlide() {
                        var currentIndex = $scope.cabins.indexOf($scope.selectedCabin),
                            index = currentIndex === $scope.cabins.length - 1 ? 0 : currentIndex + 1;
                        $scope.selectedCabin = $scope.cabins[index];
                    }
                }

            };
        }])

        .directive('listPod', function() {
            return {
                scope: {
                    list: '=',
                    title: '@'
                },
                templateUrl: 'template/list-pod.html'
            };
        })

        .directive('infiniteScroll', function() {
            return {
                link: function($scope, $element) {
                    vhols.eventDebounce(function() {
                        $scope.activityLimit += 15;
                        $scope.$apply();
                    }, 'scroll', window, 300);
                }
            };
        })

        // scroll an element into view when vhols-filters selection changes
        // use on a filtered lists container
        .directive('filterScroll', ['anchorSmoothScroll', function(anchorSmoothScroll) {
            return {
                restrict: "A",
                link: function($scope, $element) {
                    var element = $element[0],
                        margin = 30; // 30px - allow for some padding/margin on container

                    vhols.eventDebounce(function() {
                        if (element.getBoundingClientRect().bottom < margin) {
                            anchorSmoothScroll.scrollTo(element.id);
                        }
                    }, 'change', window, 300);  // 'change' is the event fired when filters change
                }
            };
        }]);
})();
